import { render, staticRenderFns } from "./VoiceIcon.vue?vue&type=template&id=3738542a&scoped=true&"
import script from "./VoiceIcon.vue?vue&type=script&lang=js&"
export * from "./VoiceIcon.vue?vue&type=script&lang=js&"
import style0 from "./VoiceIcon.vue?vue&type=style&index=0&id=3738542a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3738542a",
  null
  
)

export default component.exports